<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="fade">
    <template v-slot:activator="{ on }">
      <v-btn @click="buscarAtendimentosPorData('2023-21-09', '2023-21-09')" icon class="rounded-card white--text" color="analogoA" v-on="on">
        <v-icon>bar_chart</v-icon>
      </v-btn>
    </template>
    <v-sheet style="height: 100vh; width:100%; background-color: #f5f5f5;">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <v-icon>mdi-chart-line</v-icon>
          Estatísticas
        </v-toolbar-title>
      </v-toolbar>
      <v-container class="ma-3 text-center">
        <v-row>
          <v-col cols="3" md="3">
            <v-card outlined class="px-2" >
              <v-list>
                <v-list-item-group color="primary">
                  <v-list-item @click="selectToday(), personalizado = false">
                    Hoje
                  </v-list-item>
                  <v-list-item @click="selectYesterday(), personalizado = false">
                    Ontem
                  </v-list-item>
                  <v-list-item @click="selectLast30Days(), personalizado = false">
                    Últimos 30 dias
                  </v-list-item>
                  <v-list-item @click="personalizado = true, vouchers = [], vouchersGerados = 0">
                    Personalizado
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>
          <v-col cols="9" md="9">
            <v-card justify-content-center outlined>
               <v-row class="mt-4 mb-4 mx-1">
                  <v-col cols="12" md="4">
                    <v-item>
                      <v-card
                        class="mx-auto"
                        max-width="344"
                        outlined
                      >
                        <v-list-item three-line>
                          <v-list-item-content>
                            <div class="text-overline mb-4">
                              VOUCHERS
                            </div>
                            <v-list-item-title class="text-h5 mb-1">
                              Total
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-avatar
                            tile
                            size="80"
                            :color="loadPorData == false? 'grey': 'white'"
                          >
                            <div v-if="!loadPorData"> <h2 class="white--text">{{ vouchersGerados }}</h2> </div>
                            <v-skeleton-loader v-if="loadPorData" type="card-heading"></v-skeleton-loader>
                          </v-list-item-avatar>

                        </v-list-item>
                      </v-card>
                    </v-item>

                  </v-col>
                  <v-col cols="12" md="4">
                    <v-item>
                      <v-card
                        class="mx-auto"
                        max-width="344"
                        outlined
                      >
                        <v-list-item three-line>
                          <v-list-item-content>
                            <div class="text-overline mb-4">
                             VALOR PREVISTO
                            </div>
                            <v-list-item-title class="text-h5 mb-1">
                              <div v-if="!loadPorData">R$ {{ montante.NAOFATURADO.toFixed(2) }}</div>
                              <v-skeleton-loader v-if="loadPorData" type="list-item"></v-skeleton-loader>
                            </v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-avatar
                            tile
                            size="80"
                            color="cyan darken-1"
                          >
                            <v-icon color="white" large>currency_exchange</v-icon>
                          </v-list-item-avatar>
                        </v-list-item>
                      </v-card>
                    </v-item>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-item>
                      <v-card
                        class="mx-auto"
                        max-width="344"
                        outlined
                      >
                        <v-list-item three-line>
                          <v-list-item-content>
                            <div class="text-overline mb-4">
                              valor faturado
                            </div>
                            <v-list-item-title class="text-h5 mb-1">
                              <div v-if="!loadPorData">R$ {{ montante.FATURADO }}</div>
                              <v-skeleton-loader v-if="loadPorData" type="list-item"></v-skeleton-loader>
                            </v-list-item-title>

                          </v-list-item-content>

                          <v-list-item-avatar
                            tile
                            size="80"
                            color="yellow darken-3"
                          >
                            <v-icon color="white" large>price_check</v-icon>
                          </v-list-item-avatar>
                        </v-list-item>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>

                <v-card v-if="personalizado" flat >
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-menu v-model="menuDataInicial" :close-on-content-click="false" offset-y v-if="personalizado">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field @input="formatDate2" class="ml-2" v-model="dataInicial" label="Data Inicial" readonly v-bind="attrs" v-on="on" prepend-icon="mdi-calendar"></v-text-field>
                        </template>
                        <v-date-picker landscape v-model="dataInicial" :max="dataFinal" :disabled-dates="disabledDatesInicial" :disabled="loadPorData" locale="pt-br"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-menu v-model="menuDataFinal" :close-on-content-click="false" offset-y v-if="personalizado">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="dataFinal" label="Data Final" readonly v-bind="attrs" v-on="on" prepend-icon="mdi-calendar"></v-text-field>
                        </template>

                        <v-date-picker landscape v-model="dataFinal" :min="dataInicial" locale="pt-br" :disabled="loadPorData"></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-btn v-if="personalizado" :loading="loadPorData" @click="buscarAtendimentosPorData(dataInicial, dataFinal)" class="mt-3 ml-2 rounded" color="primary">Filtrar</v-btn>
                    </v-col>
                  </v-row>
                </v-card>

                <!-- <v-skeleton-loader v-if="loadPorData" :type="attrs.type"></v-skeleton-loader> -->
                <v-divider />
                <v-card-title >Receita</v-card-title>

                <v-simple-table v-if="!loadPorData" dense height="300px" style="overflow-y: auto;">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Ordem de serviço
                        </th>
                        <th class="text-left">
                          Liberação
                        </th>
                        <th class="text-left">
                          Execução
                        </th>
                        <th class="text-left">
                          Repasse
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, i) in vouchers" :key="i" class="text-left">
                        <td><strong>{{ item.repasse.idOS }}</strong></td>
                        <td>
                          <v-chip label dark small class="custom-chip" :class="{'not-faturado': item.repasse.statusFatura == 'NAOFATURADO', 'nao-repasse': item.repasse.statusFatura == 'NAOREPASSE'}" :color="item.repasse.statusFatura == 'NAOFATURADO' ? 'cyan darken-1' : item.repasse.statusFatura == 'NAOREPASSE' ? 'grey darken-1' : 'green lighten-1'">
                          <v-icon left small v-text="item.repasse.statusFatura == 'NAOFATURADO' ? 'currency_exchange' : item.repasse.statusFatura == 'NAOREPASSE' ? 'money_off' : 'price_check'"></v-icon>
                          {{ item.repasse.statusFatura == 'NAOFATURADO' ? 'Não faturado' : item.repasse.statusFatura == 'NAOREPASSE' ? 'Não repassado' : 'Faturado' }}
                        </v-chip>
                        </td>
                        <td>
                          <v-chip dark label small class="custom-chip" :class="{'aguardando-paciente': item.repasse.statusExecuta == 'AGUARDANDOPACIENTE', 'liberado': item.repasse.statusExecuta == 'LIBERADO' && item.repasse.statusFatura !== 'NAOREPASSE', 'liberado-parcial': item.repasse.statusExecuta == 'LIBERADOPARCIAL' && item.repasse.statusFatura !== 'NAOREPASSE', 'aberto': item.repasse.statusExecuta == 'ABERTO'}" :color="item.repasse.statusExecuta == 'AGUARDANDOPACIENTE' ? 'cyan darken-1' : item.repasse.statusExecuta == 'LIBERADO' ? 'green' : item.repasse.statusExecuta == 'LIBERADOPARCIAL' ? 'lime darken-2' : 'blue lighten-1'">
                            <v-icon small left v-if="item.repasse.statusExecuta == 'AGUARDANDOPACIENTE'">pending_actions</v-icon>
                            <v-icon small left v-else-if="item.repasse.statusExecuta == 'LIBERADO' && item.repasse.statusFatura !== 'NAOREPASSE'">task_alt</v-icon>
                            <v-icon small left v-else-if="item.repasse.statusExecuta == 'LIBERADOPARCIAL' && item.repasse.statusFatura !== 'NAOREPASSE'">hourglass_bottom</v-icon>
                            <v-icon small left v-else>folder_open</v-icon>
                            {{ item.repasse.statusExecuta == 'AGUARDANDOPACIENTE' ? 'Aguardando paciente' : (item.repasse.statusExecuta == 'LIBERADO' && item.repasse.statusFatura !== 'NAOREPASSE' ? 'Liberado' : (item.repasse.statusExecuta == 'LIBERADOPARCIAL' && item.repasse.statusFatura !== 'NAOREPASSE' ? 'Liberado parcialmente' : 'Aberto')) }}
                          </v-chip>
                        </td>
                        <td>
                          <v-chip label small class="custom-chip" :color="item.repasse.statusFatura === 'FATURADO' ? 'yellow darken-3' : 'grey lighten-3'" :style="{ color: item.repasse.statusFatura === 'FATURADO' ? 'white' : 'inherit', textDecoration: item.repasse.statusFatura === 'NAOREPASSE' ? 'line-through' : 'none' }">
                            <!-- <v-icon small left>mdi-currency-usd</v-icon> -->
                            <strong>{{ item.repasse.ValorRepasse.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</strong>
                          </v-chip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  </v-simple-table>
                  <v-skeleton-loader v-if="loadPorData" :type="attrs.type"></v-skeleton-loader>
              </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-dialog>
</template>

<script>
// import VueApexCharts from 'vue-apexcharts'
import nutricionistaService from '../../services/nutricionistaService'

export default {
  components: {
    // apexchart: VueApexCharts
  },
  data () {
    return {
      user: '',
      load: false,
      dialog: false,
      mediaTempoAtendimentoDiario: '',
      totalAtendimentosDiario: '',
      mediaTempoAtendimentoMensal: '',
      totalAtendimentosMensal: '',
      mediaTempoAtendimentoAnual: '',
      totalAtendimentosAnual: '',
      montante: {
        'NAOFATURADO': 0,
        'FATURADO': 0
      },
      dates: [],
      series: [
        {
          name: 'Receita R$',
          type: 'column',
          data: [440, 505, 414, 671, 227, 413, 201, 352, 752, 320, 257, 160]
        },
        {
          name: 'Vochers Gerados',
          type: 'line',
          data: [23, 42, 35, 27, 43, 22, 17, 31, 22, 22, 12, 16]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line'
        },
        stroke: {
          width: [0, 4]
        },
        title: {
          text: 'Resumo semanal'
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1]
        },
        labels: [
          '01 Jan 2001',
          '02 Jan 2001',
          '03 Jan 2001',
          '04 Jan 2001',
          '05 Jan 2001',
          '06 Jan 2001',
          '07 Jan 2001',
          '08 Jan 2001',
          '09 Jan 2001',
          '10 Jan 2001',
          '11 Jan 2001',
          '12 Jan 2001'
        ],
        xaxis: {
          type: 'datetime'
        },
        yaxis: [
          {
            title: {
              text: 'Receita R$ '
            }
          },
          {
            opposite: true,
            title: {
              text: 'Vouchers'
            }
          }
        ]
      },
      mediaHorarios: null,
      chart: '',
      loadMetricasDiarias: false,
      dataInicial: null,
      dataFinal: null,
      menuDataInicial: false,
      menuDataFinal: false,
      personalizado: false,
      loadPorData: false,
      vouchersGerados: 0,
      vouchers: []
    }
  },
  methods: {
    formatDate2 () {
      if (this.selectedDate) {
        const day = this.selectedDate.getDate()
        const month = this.selectedDate.getMonth() + 1
        const year = this.selectedDate.getFullYear()
        this.selectedDate = `${day.toString().padStart(2, '0')}-${month.toString().padStart(2, '0')}-${year}`
      }
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    async buscarAtendimentosPorData (data1, data2) {
      this.loadPorData = true
      this.vouchers = []
      try {
        const { data } = await nutricionistaService.nutricionista.buscarAtendimentosPorData(this.user.id, data1, data2)
        this.vouchers = data
        this.vouchersGerados = data.length
        /* data[0].repasse.statusFatura = 'FATURADO'
        data[0].repasse.statusExecuta = 'LIBERADO'
        data[0].repasse.ValorRepasse = 102.50
        data[1].repasse.statusFatura = 'NAOREPASSE'
        data[1].repasse.statusExecuta = 'AGUARDANDOPACIENTE' */
        this.calcularMontantePorStatus(data)
        // console.log(montantePorStatus)
      } catch (error) {
        console.error(error)
      } finally {
        this.loadPorData = false
      }
    },
    selectLast30Days () {
      const today = new Date()
      const last30Days = new Date(today)
      last30Days.setDate(today.getDate() - 30)

      const formattedStartDate = this.formatDate(last30Days)
      const formattedEndDate = this.formatDate(today)

      this.dataInicial = formattedStartDate
      this.dataFinal = formattedEndDate

      this.buscarAtendimentosPorData(formattedStartDate, formattedEndDate)
    },
    selectYesterday () {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      const formattedStartDate = this.formatDate(yesterday)

      this.dataInicial = formattedStartDate
      this.dataFinal = formattedStartDate
      this.buscarAtendimentosPorData(this.dataInicial, this.dataFinal)
    },
    selectToday () {
      const today = new Date()
      const formattedStartDate = this.formatDate(today)
      this.dataInicial = formattedStartDate
      this.dataFinal = formattedStartDate
      this.buscarAtendimentosPorData(this.dataInicial, this.dataFinal)
    },
    // função para calcular o montante por status
    calcularMontantePorStatus (vouchers) {
      this.montante = {
        'NAOFATURADO': 0,
        'FATURADO': 0
      }

      vouchers.forEach((item) => {
        this.montante[item.repasse.statusFatura] += item.repasse.ValorRepasse
        this.montante[item.repasse.statusExecuta] += item.repasse.ValorRepasse
      })

      // return montantePorStatus
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
  },
  computed: {
    disabledDatesInicial () {
      if (this.dataFinal) {
        return { before: this.dataFinal }
      }
      return null
    },
    maxDate () {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today
    },
    attrs () {
      return { type: 'list-item' }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
